import {
  MEMBER_INFO_FETCH,
  MEMBER_INFO_FETCH_SUCCESS,
  MEMBER_INFO_FETCH_FAIL,

  MEMBER_CHANGE_PASS,
  MEMBER_CHANGE_PASS_SUCCESS,
  MEMBER_CHANGE_PASS_FAIL,

  MEMBER_EDIT,
  MEMBER_EDIT_SUCESS,
  MEMBER_EDIT_FAIL,

  FAVORITE_LIST_FETCH,
  FAVORITE_LIST_FETCH_SUCESS,
  FAVORITE_LIST_FETCH_FAIL,

  MEMBER_UPLOAD,
  MEMBER_UPLOAD_SUCESS,
  MEMBER_UPLOAD_FAIL,

  NOTIFICATION_FETCH,
  NOTIFICATION_FETCH_SUCCESS,
  NOTIFICATION_FETCH_FAIL,

  MEMBER_DELETE,
  MEMBER_DELETE_SUCCESS,
  MEMBER_DELETE_FAIL,

  MEMBER_HISTORY_FETCH,
  MEMBER_HISTORY_FETCH_SUCCESS,
  MEMBER_HISTORY_FETCH_FAIL,


  MEMBER_UPDATE_SHOW_NOTI,
  MEMBER_UPDATE_SHOW_NOTI_SUCESS,
  MEMBER_UPDATE_SHOW_NOTI_FAIL

} from '../actions'

const INIT_STATE = {
  memberInfo: [],
  memberLoading: false,
  memberError: '',
  changePassLoading: false,
  changePassError: '',
  changePass: [],
  saveTypeChangepass: '',
  memberLogin: localStorage.getItem('user_info'),
  memberEditinfoLoading: false,
  memberEditinfoError: '',
  memberEditinfo: [],
  favoriteListLoading: false,
  favoriteListError: '',
  favoriteList: [],
  uploadPic: false,
  uploadStatus: false,
  upload: [],
  error: '',
  ontificationListLoading: false,
  ontificationListError: '',
  ontificationList: [],
  memberDeleteLoading: false,
  memberDeleteError: '',
  memberDelete: '',
  memberHistoryLoading: false,
  memberHistoryError: '',
  memberHistory: [],
  memberUpdateShowNotiLoading: false,
  memberUpdateShowNotiError: '',
}

export default (state = INIT_STATE, action) => {
  // console.log('action.payload -> ', action.payload)
  switch (action.type) {
    /* member fetch */
    case MEMBER_INFO_FETCH:
      return { ...state, memberLoading: true, memberError: '' };
    case MEMBER_INFO_FETCH_SUCCESS:
      return { ...state, memberLoading: false, memberInfo: action.payload, memberError: '' };
    case MEMBER_INFO_FETCH_FAIL:
      return { ...state, memberLoading: false, memberInfo: [], memberError: action.payload.message };

    /* change password */
    case MEMBER_CHANGE_PASS:
      return { ...state, changePassLoading: true, changePassError: '', saveTypeChangepass: action.payload.changePass.saveType };
    case MEMBER_CHANGE_PASS_SUCCESS:
      return { ...state, changePassLoading: false, changePass: action.payload, changePassError: '' };
    case MEMBER_CHANGE_PASS_FAIL:
      return { ...state, changePassLoading: false, changePass: [], changePassError: action.payload.message };

    /* edit member info */
    case MEMBER_EDIT:
      return { ...state, memberEditinfoLoading: true, memberEditinfoError: '', saveType: action.payload.memberEditinfo.saveType }
    case MEMBER_EDIT_SUCESS:
      return { ...state, memberEditinfoLoading: false, memberEditinfo: action.payload.memberEditinfo, memberEditinfoError: '' }
    case MEMBER_EDIT_FAIL:
      return { ...state, memberEditinfoLoading: false, memberEditinfo: [], memberEditinfoError: action.payload.message }

    /* favorite list */
    case FAVORITE_LIST_FETCH:
      return { ...state, favoriteListLoading: true, favoriteListError: '' }
    case FAVORITE_LIST_FETCH_SUCESS:
      return { ...state, favoriteListLoading: false, favoriteList: action.payload.favoriteList, favoriteListError: '' }
    case FAVORITE_LIST_FETCH_FAIL:
      return { ...state, favoriteListLoading: false, favoriteList: [], favoriteListError: action.payload.message }

    /* Upload */
    case MEMBER_UPLOAD:
      return { ...state, uploadPic: true, error: '', uploadStatus: false };
    case MEMBER_UPLOAD_SUCESS:
      return { ...state, uploadPic: false, uploadStatus: true, error: '', upload: action.payload };
    case MEMBER_UPLOAD_FAIL:
      return { ...state, uploadPic: false, uploadStatus: false, error: action.payload.message, upload: [] };

    /* ontification list */
    case NOTIFICATION_FETCH:
      return { ...state, ontificationListLoading: true, ontificationListError: '' }
    case NOTIFICATION_FETCH_SUCCESS:
      return { ...state, ontificationListLoading: false, ontificationList: action.payload.ontificationList, ontificationListError: '' }
    case NOTIFICATION_FETCH_FAIL:
      return { ...state, ontificationListLoading: false, ontificationList: [], ontificationListError: action.payload.message }

    /* delete */
    case MEMBER_DELETE:
      return { ...state, memberDeleteLoading: true, memberDeleteError: '' }
    case MEMBER_DELETE_SUCCESS:
      return { ...state, memberDeleteLoading: false, memberDelete: action.payload.memberDelete, memberDeleteError: '' }
    case MEMBER_DELETE_FAIL:
      return { ...state, memberDeleteLoading: false, memberDelete: '', memberDeleteError: action.payload.message }

    /* history */
    case MEMBER_HISTORY_FETCH:
      return { ...state, memberHistoryLoading: true, memberHistoryError: '' }
    case MEMBER_HISTORY_FETCH_SUCCESS:
      return { ...state, memberHistoryLoading: false, memberHistory: action.payload.memberHistory, memberHistoryError: '' }
    case MEMBER_HISTORY_FETCH_FAIL:
      return { ...state, memberHistoryLoading: false, memberHistory: [], memberHistoryError: action.payload.message }


    /* edit member info */
    case MEMBER_UPDATE_SHOW_NOTI:
      return { ...state, memberUpdateShowNotiLoading: true, memberUpdateShowNotiError: '' }
    case MEMBER_UPDATE_SHOW_NOTI_SUCESS:
      return { ...state, memberUpdateShowNotiLoading: false, memberUpdateShowNotiError: '' }
    case MEMBER_UPDATE_SHOW_NOTI_FAIL:
      return { ...state, memberUpdateShowNotiLoading: false, memberUpdateShowNotiError: action.payload.message }

    default:
      return { ...state }
  }
}